import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchNutritionDailyArgs,
  FetchIntakeArgs,
} from '../api/types/statsInsights.types';

import {
  fetchNutritionDaily,
  fetchNutrients,
  fetchIntake,
} from '../api/nutritionStats.api';

export const statsNutritionQueryKeys = createQueryKeys('statsNutrition', {
  fetchIntake: (args: FetchIntakeArgs = {}) => ({
    queryFn: () => fetchIntake(args),
    queryKey: [args],
  }),
  fetchNutrients: {
    queryFn: () => fetchNutrients(),
    queryKey: null,
  },
  fetchNutritionDaily: (args: FetchNutritionDailyArgs = {}) => ({
    queryFn: () => fetchNutritionDaily(args),
    queryKey: [args],
  }),
});
